import {types} from '../../types';

const setGetAmountReferralsAction = (payload) => {
    return {
        type: types.referrals.SET_AMOUNT,
        payload,
      }
}

const setGetReferralsAction = (payload) => {
  return {
    type: types.referrals.SET_REFERRALS,
    payload,
  }
}

const setGetViewReferralAction = (payload) => {
  return {
    type: types.referrals.SET_REFERRAL_INFO,
    payload,
  }
}

export {
  setGetAmountReferralsAction as SetGetAmountReferralsAction,
  setGetReferralsAction as SetGetReferralsAction,
  setGetViewReferralAction as SetGetViewReferralAction
}